import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    padding: $theme.sizing.scale400,
    display: 'flex',
    gap: $theme.sizing.scale400,
    borderBottom: '1px solid #DEDEDE',
    cursor: 'pointer',
    width: '100%'
}))

export const LocationIcon = styled('i', ({ $theme }) => ({
    color: $theme.colors.primary,
    fontSize: '1.4rem',
    marginTop: '0.6rem'
}))

export const Name = styled('div', ({ $theme }) => ({
    fontSize: '1.6rem',
    lineHeight: '2rem',
    fontWeight: 300
}))

export const CountryCode = styled('div', ({ $theme }) => ({
    fontSize: '1.1rem',
    lineHeight: '2rem',
    fontWeight: 300
}))
